import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["href"]

import {computed, getCurrentInstance, onBeforeUnmount, ref} from 'vue';
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {ChatEventManagerInstance} from "~/chat/ts/ChatEventManager";
import ChatMessageFileContentDescription from "~/chat/vue/widget/tabs/chat/ChatMessageFileContentDescription.vue";
import {IMessageAttachment} from "~/chat/ts/data/chat/IMessage";
import ChatDateHelper from "~/chat/ts/service/ChatDateHelper";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "ChatAudioPlayButton"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    attachment: {},
    showDuration: { type: Boolean, default: true },
    showDownload: { type: Boolean },
    fileName: {}
  },
  setup(__props: any) {

const PLAY_EVENT = "audioPlayButtonStarted";


let props = __props;

let instance = getCurrentInstance().proxy;

let isPlaying = ref(false);
let duration = ref<number>();

let audio: HTMLAudioElement = new Audio();
audio.addEventListener("play", () => onPlay());
audio.addEventListener("playing", () => onPlay());
audio.addEventListener("pause", () => onPause());
audio.addEventListener("loadedmetadata", () => detectDuration());

if (props.showDuration) {
    audio.src = props.attachment.url;
}

function str_pad_left(string: string, pad: string, length: number) {
    return (new Array(length + 1).join(pad) + string).slice(-length);
}


let durationDescr = computed(() => {
    let time = duration.value;
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;

    return str_pad_left(minutes.toString(), '0', 2) + ':' + str_pad_left(seconds.toString(), '0', 2);
    // return duration.value && duration.value != Infinity ? moment.utc(duration.value * 1000).format("mm:ss") : null;
});

function getFixedDuration(): Promise<number> {
    return new Promise(async resolve => {
        let currentTime = audio.currentTime;
        let volume = audio.volume;
        let callback = () => {
            let _duration = audio.duration;
            if (_duration != Infinity && !isNaN(_duration)) {
                duration.value = audio.duration;
                audio.removeEventListener("durationchange", callback);
                try {
                    audio.pause();
                } catch (e) {

                }
                audio.currentTime = currentTime;
                audio.volume = volume;
                resolve(_duration);
            }
        };
        try {
            audio.addEventListener("durationchange", callback, false);
            audio.load();
            audio.currentTime = 24 * 60 * 60; //fake big time
            audio.volume = 0;
            await audio.play();
        } catch (e) {
        }
    });
}

let detectDurationStarted = ref(false);

async function detectDuration() {
    if (!detectDurationStarted.value) {
        detectDurationStarted.value = true;
        let _duration = audio.duration;
        if (_duration == Infinity || isNaN(_duration)) {
            _duration = await getFixedDuration();
        }

        duration.value = isNaN(_duration) ? null : Math.round(_duration);
        detectDurationStarted.value = false;
    }
}


onBeforeUnmount(() => {
    try {
        audio.pause();
    } catch (e) {

    }
    audio.remove();
});

let icon = computed(() => {
    return isPlaying.value && !detectDurationStarted.value ? "pause" : "play";
});

function onPlay() {
    isPlaying.value = true;
    ChatEventManagerInstance.emit(PLAY_EVENT, {
        instance: instance
    });
}

function onPause() {
    isPlaying.value = false;
}

function pause() {
    if (isPlaying.value) {
        audio.pause();
    }
}

async function play() {
    if (!isPlaying.value) {
        if (audio.src != props.attachment.url) {
            audio.src = props.attachment.url;
        }
        audio.currentTime = 0;
        await detectDuration();
        audio.play();
    }
}

function onClick() {
    if (isPlaying.value) {
        pause();
    } else {
        play();
    }
}

addDisposableEvent(
    ChatEventManagerInstance.addEventListener(PLAY_EVENT, (data) => {
        if (data.instance != instance) {
            pause();
        }
    })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex",
    onClick: _withModifiers(onClick, ["stop"])
  }, [
    _createVNode(ChatMessageFileContentDescription, {
      attachment: _ctx.attachment,
      icon: _unref(icon)
    }, {
      size: _withCtx(() => [
        (_unref(durationDescr))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(durationDescr)) + ", ", 1)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          target: "_blank",
          href: _ctx.attachment.url,
          class: "download"
        }, _toDisplayString(_unref(__)("Скачать")), 9, _hoisted_1)
      ]),
      _: 1
    }, 8, ["attachment", "icon"])
  ]))
}
}

})